import { useEffect, useState } from 'react';
import { TicketsService } from '../../../services/tickets';

const ticketsService = new TicketsService();

export const useTicketsConfig = () => {
  const [ticketsConfig, setTicketsConfig] = useState<any>();

  const fetchTicketsConfig = async () => {
    const data = await ticketsService.getTicketsConfig();
    setTicketsConfig(data.Buttons);
  };

  useEffect(() => {
    fetchTicketsConfig();
  }, []);

  return { ticketsConfig };
};
